var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calories",
    transform: "translate(-799 -458)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2226",
    "data-name": "Rectangle 2226",
    width: 64,
    height: 64,
    transform: "translate(799 458)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fork_spoon",
    transform: "translate(792.109 458.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    "data-name": "Group 1777",
    transform: "translate(18.6 4.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1774",
    "data-name": "Group 1774",
    transform: "translate(21.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1772",
    "data-name": "Group 1772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M75.477,57.692a5.041,5.041,0,0,1-3.75-1.652,6.07,6.07,0,0,1-1.607-4.33l1.83-23.349a1.3,1.3,0,0,0-.67-1.25c-2.679-1.518-5.58-4.554-5.58-8.393V14.477a9.777,9.777,0,1,1,19.554,0v4.2c0,3.839-2.857,6.83-5.58,8.393a1.346,1.346,0,0,0-.67,1.25l1.83,23.349a5.988,5.988,0,0,1-1.607,4.375,5.041,5.041,0,0,1-3.75,1.652Zm0-51.251a7.983,7.983,0,0,0-7.991,7.991v4.241c0,3.08,2.5,5.58,4.688,6.83a3.024,3.024,0,0,1,1.563,2.946L71.905,51.8a4.1,4.1,0,0,0,1.116,2.991,3.354,3.354,0,0,0,2.455,1.071,3.534,3.534,0,0,0,2.455-1.071,4.138,4.138,0,0,0,1.116-3.036l-1.83-23.259a3.139,3.139,0,0,1,1.563-2.946c2.143-1.205,4.688-3.75,4.688-6.83V14.477a8.119,8.119,0,0,0-2.321-5.67,7.972,7.972,0,0,0-5.67-2.366Z",
    transform: "translate(-65.7 -4.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1773",
    "data-name": "Group 1773",
    transform: "translate(8.884 4.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M90.913,20.905a.9.9,0,0,1-.893-.893,3.506,3.506,0,0,0-3.527-3.527.893.893,0,0,1,0-1.786,5.3,5.3,0,0,1,5.313,5.313A.9.9,0,0,1,90.913,20.905Z",
    transform: "translate(-85.6 -14.7)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1776",
    "data-name": "Group 1776",
    transform: "translate(0 0.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1775",
    "data-name": "Group 1775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M28.332,57.717a5.21,5.21,0,0,1-3.795-1.652,5.709,5.709,0,0,1-1.563-4.241L24.85,28.386a1.371,1.371,0,0,0-.67-1.295c-2.723-1.518-5.58-4.554-5.58-8.393V8.52a3.034,3.034,0,0,1,.893-2.188,2.906,2.906,0,0,1,2.1-.893,2.773,2.773,0,0,1,2.188.893A3.345,3.345,0,0,1,24.761,8.7v7.411a.2.2,0,0,0,.045.134.164.164,0,0,0,.134.045.211.211,0,0,0,.223-.223V8.52a3.034,3.034,0,0,1,.893-2.188,3.068,3.068,0,0,1,4.286-.045,3.389,3.389,0,0,1,1.027,2.366v7.411a.2.2,0,0,0,.045.134c.045.045.089.089.179.045.089,0,.179-.134.179-.268V8.52a3.034,3.034,0,0,1,.893-2.188,3.237,3.237,0,0,1,2.1-.938,2.773,2.773,0,0,1,2.188.893,3.345,3.345,0,0,1,.982,2.366V18.743a9.722,9.722,0,0,1-2.857,6.92,7.975,7.975,0,0,1-2.589,1.518,1.321,1.321,0,0,0-.8,1.339l1.83,23.259a5.746,5.746,0,0,1-1.563,4.286A4.56,4.56,0,0,1,28.332,57.717Zm-6.7-50.536a1.216,1.216,0,0,0-.938.4,1.285,1.285,0,0,0-.4.938V18.743c0,3.08,2.545,5.58,4.688,6.83a3.024,3.024,0,0,1,1.563,2.946L24.672,51.913a4.042,4.042,0,0,0,1.071,2.9,3.379,3.379,0,0,0,2.5,1.071,3.555,3.555,0,0,0,2.5-1.071,4.078,4.078,0,0,0,1.071-2.946l-1.83-23.259a3.191,3.191,0,0,1,1.875-3.125,8.784,8.784,0,0,0,2.009-1.161,7.93,7.93,0,0,0,2.321-5.67v-10a1.559,1.559,0,0,0-.446-1.071,1.059,1.059,0,0,0-.893-.357,1.124,1.124,0,0,0-.893.4,1.285,1.285,0,0,0-.4.938V16.02a2.017,2.017,0,0,1-3.438,1.473,2.065,2.065,0,0,1-.58-1.429V8.609a1.559,1.559,0,0,0-.446-1.071,1.1,1.1,0,0,0-.938-.357,1.263,1.263,0,0,0-.893.4,1.285,1.285,0,0,0-.4.938v7.5a2,2,0,0,1-2.009,2.009,2.15,2.15,0,0,1-1.429-.58,2.065,2.065,0,0,1-.58-1.429V8.609a1.559,1.559,0,0,0-.446-1.071.893.893,0,0,0-.759-.357Z",
    transform: "translate(-18.6 -5.391)",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalories);
export default __webpack_public_path__ + "static/media/calories.c25f9a16324a91d717bca919ced0398a.svg";
export { ForwardRef as ReactComponent };